<div class="arquivo-card-filter">
    <div class="arquivo-card-filter-itens">
        <div class="arquivo-card-filter-item">
            <sgt-tipo-arquivo-multiselect
                [(idsTiposArquivos)]="filter.idsTiposArquivos"
                (idsTiposArquivosChange)="onChangeTiposArquivos()"
                [showNullOption]="true"
                [(nullOption)]="filter.tipoArquivoNull"
                [searchOnInit]="false"
                [referenciaFilter]="filter.referencia ? filter.referencia.id : null"
                [dropup]="dropupMultiselects"
                defaultTitle="Tipos">
            </sgt-tipo-arquivo-multiselect>
        </div>
        <div class="arquivo-card-filter-item">
            <sgt-usuario-multiselect
                [(idsUsuarios)]="filter.idsUsuariosCreated"
                (idsUsuariosChange)="onChangeUsuariosCreated()"
                [dropup]="dropupMultiselects"
                defaultTitle="Adicionado Por">
            </sgt-usuario-multiselect>
        </div>
        <div class="arquivo-card-filter-item arquivo-card-filter-item-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar os arquivos...">
        </div>
    </div>
    <div class="arquivo-card-filter-options">
        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar">
            <i class="fas fa-eraser" aria-hidden="true"></i> Limpar
        </button>
    </div>    
</div>